import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { entityTechDocsIconLink } from './EntityTechDocsIconLink';

export const techdocsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [entityTechDocsIconLink],
});
